
  <template >
 <div v-role="'func'">
  <div class="formPosition">
    <v-overlay v-model="overlay">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
<v-tabs
  v-model="tab"
  align-tabs="center"
  color="deep-purple-darken-3"
  bg-color="white"
  grow
  height="60"
  class="elevation-1"
>
  <v-tab 
    :value="0" 
    class="text-capitalize font-weight-medium"
    :class="{'primary--text': tab === 0}"
  >
    <v-icon start size="20">mdi-account-school-outline</v-icon>
    Registro do Estudante
   
  </v-tab>
  
  <v-tab 
    :value="1" 
    class="text-capitalize font-weight-medium"
    :class="{'primary--text': tab === 1}"
    :disabled="true"
   >
    <v-icon start size="20">mdi-certificate-outline</v-icon>
    Lançamento de Notas 
   
    
  </v-tab>
 

<v-divider class="mb-4"></v-divider>

   <!-- Tab 1: Formulário de Registro -->
  <v-tab-item :key="0">
      <v-card class="elevation-4">
      <!-- Cabeçalho com ações -->
        <v-card-title class="d-flex align-center justify-space-between primary--text">
          <div class="d-flex align-center">
            <v-icon left color="primary">mdi-account-school</v-icon>
            Registro de Estudante Finalista (Antes do sistema)
          </div>
          <v-btn color="primary" outlined @click="$router.push('minhas-solicitacoes')">
            <v-icon left>mdi-eye</v-icon>
            Visualizar Solicitações 
          </v-btn>
        </v-card-title>

 
  <v-container class="d-flex justify-center align-center fill-height">
    <v-card width="1200px"  >
      <!-- Formulário principal -->
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container class="py-4 px-6" fluid>
          <!-- Layout em duas colunas para melhor aproveitamento de espaço -->
          <v-row>
            <!-- Coluna esquerda -->
            <v-col cols="12" md="12">
              <!-- Seção: Dados Pessoais -->
                  
                 <v-card-text class="pt-4">
                  
                  
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="editedItem.bi" 
                        :rules="ruleBI" 
                        :label="descricao" 
                        v-mask="mascara" 
                        ref="biField"
                        required 
                        outlined
                        dense
                        prepend-inner-icon="mdi-card-account-details-outline"
                      ></v-text-field>

                      <v-snackbar 
                        v-model="showAlert" 
                        timeout="6000" 
                        color="amber lighten-4" 
                        top 
                        multi-line
                      >
                        <div style="color: #6D4C00; font-weight: bold;">
                          🔔 <strong>ATENÇÃO:</strong>
                        </div>
                        
                        <p style="color: #424242; margin-top: 8px;">
                          O número de bilhete inserido está sendo usado por outro estudante.<br>
                         </p>

                        <v-divider class="my-2" style="border-color: #D1C4A9;"></v-divider>

                        <p style="color: #424242;margin-bottom: 4px;"><strong>Nome:</strong> {{ infoStudants.nome }}</p>
                        <p style="color: #424242;margin-bottom: 4px;"><strong>Instituição:</strong> {{ infoStudants.instituicaodescricao }}</p>

                      </v-snackbar>
 
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field 
                        v-model="editedItem.nome" 
                        :rules="ruleTextRequired" 
                        label="Nome Completo" 
                        :disabled="disabledFields"
                        outlined
                        dense
                        prepend-inner-icon="mdi-account-outline"
                        class="mb-4"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-menu 
                        ref="menubi" 
                        v-model="menubi" 
                        :close-on-content-click="false" 
                        transition="scale-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field 
                            v-model="editedItem.dataemissaobi" 
                            :rules="[v => !!v || 'Campo obrigatório!']" 
                            label="Emissão BI" 
                            prepend-inner-icon="mdi-calendar" 
                            readonly 
                            :disabled="disabledFields"
                            outlined
                            dense
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker 
                          ref="picker" 
                          v-model="datebi" 
                          max="2025-12-31" 
                          min="1950-01-01" 
                          @change="saveDatebi"
                          locale="pt"
                        ></v-date-picker>
                        
                      </v-menu>
                    </v-col>


                    <v-col cols="12" md="6">
                  <v-combobox 
                    v-model="editedItem.sexo" 
                    :items="dropdowSexo" 
                    :disabled="disabledFields"
                    item-value="idSexo" 
                    item-text="descricao" 
                    :rules="ruleRequired" 
                    label="Sexo" 
                    outlined
                    dense
                    prepend-inner-icon="mdi-gender-male-female"
                   ></v-combobox>
                  </v-col>

                  <v-col cols="12" md="6">
                     <v-menu 
                        ref="menu" 
                        v-model="menu" 
                        :close-on-content-click="false" 
                        transition="scale-transition"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field 
                            v-model="editedItem.datanascimento" 
                            :rules="[v => !!v || 'Campo obrigatório!']" 
                            label="Data de nascimento" 
                            prepend-inner-icon="mdi-calendar" 
                            readonly 
                            :disabled="disabledFields"
                            outlined
                            dense
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker 
                          ref="picker" 
                          v-model="date" 
                          max="2006-12-31"
                          min="1950-01-01"
                          @change="saveDate"
                          locale="pt"
                        ></v-date-picker>
                      </v-menu>
                  </v-col>
                  
                  <v-col cols="12" md="6">
                   <v-text-field 
                    v-model="editedItem.nomedopai" 
                    label="Nome do Pai" 
                    outlined
                    :disabled="disabledFields"
                    dense
                    prepend-inner-icon="mdi-account-male"
                    class="mb-4"
                  ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="editedItem.nomedamae" 
                    label="Nome da Mãe" 
                    outlined
                    :disabled="disabledFields"
                    dense
                    prepend-inner-icon="mdi-account-female"
                  ></v-text-field> 
                  </v-col>

                  <v-col cols="12" md="6">
                  <v-combobox 
                    v-model="proviSelectedForComb" 
                    :items="provincias" 
                    item-value="idProvicia" 
                    item-text="descricao" 
                    :rules="ruleRequired" 
                    label="Província" 
                    :disabled="disabledFields"
                    outlined
                    dense
                    prepend-inner-icon="mdi-map-outline"
                    @change="loadMunicipioComb"
                    class="mb-4"
                  ></v-combobox>
                  </v-col>

                  <v-col cols="12" md="6">
                  
                  <v-combobox 
                    v-model="municSelectedForComb" 
                    :items="municipiosFiltered" 
                    item-value="idMunicipio" 
                    item-text="descricao" 
                    :rules="ruleRequired" 
                    label="Município" 
                    outlined
                    dense
                    prepend-inner-icon="mdi-city"
                    :disabled="!proviSelectedForComb"
                  ></v-combobox>

                  </v-col>


                   <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="editedItem.telefone" 
                    label="Telefone" 
                    outlined
                    :disabled="disabledFields"
                    dense
                    prepend-inner-icon="mdi-phone-outline"
                    v-mask="'###-##-##-##'"
                    hint="Formato: XXX-XX-XX-XX"
                    persistent-hint
                  ></v-text-field>
                   </v-col>
  
               
                 <v-col cols="12" md="4">
                  <v-combobox 
                    v-model="editedItem.anolectivo" 
                    :items="anolectivos" 
                    item-value="idAnoLectivo" 
                    item-text="novadescricao" 
                    :rules="ruleRequired" 
                    :disabled="disabledFields"
                    label="Ano Letivo" 
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar-text"
                    class="mb-4"
                  ></v-combobox>

                 </v-col>

                  <v-col cols="12" md="4">
                  
                  <v-combobox 
                    v-model="editedItem.curso" 
                    :items="cursos" 
                    item-value="idCurso" 
                    item-text="descricao" 
                    :disabled="disabledFields"
                    :rules="ruleRequired" 
                    label="Curso" 
                    outlined
                    dense
                    prepend-inner-icon="mdi-book-education-outline"
                  ></v-combobox>

                  </v-col>
                  
                  </v-row>
                   
                </v-card-text>
  
             </v-col>
 
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-container>

      <!-- Rodapé fixo -->
     <v-card-actions class="px-6 py-4 bg-grey-lighten-4">
  <v-spacer></v-spacer>
  <v-btn 
    :disabled="!valid || disabledFields || loading"
    color="primary"
    @click="nextTab()"
    class="px-6"
    depressed
    large
     v-if="!loading"
  >
    
   <v-icon left>mdi-chevron-right</v-icon>
    GRAVAR E CONTINUAR
  </v-btn>

   <div v-else class="d-flex align-center justify-end" style="gap: 14px;">
  <span class="caption grey--text text--darken-1">Carregando disciplinas...</span>
  <v-progress-circular
    indeterminate
    color="success"
    size="30"
    width="3"
  ></v-progress-circular>
</div>
</v-card-actions>
    </v-card>
  </v-tab-item>

  <!-- Tab 2: Lançamento de Notas -->
  <v-tab-item :key="1">
    <v-container class="d-flex justify-center align-center fill-height">
    <v-card width="1200px"  >
    <v-form ref="form" v-model="formValid" lazy-validation>
    <v-card class="elevation-2">
  <v-card-title class="d-flex align-center primary--text">
    <v-icon left color="primary">mdi-certificate</v-icon>
    Lançamento de Notas do Certificado
  </v-card-title>
  
  <v-card-text>
    <!-- Cabeçalho da tabela -->
    <v-row class="header-row grey lighten-3 py-2 mb-2 mx-0" dense>
      <v-col cols="1" class="text-center font-weight-bold">Nº</v-col>
      <v-col cols="6" class="font-weight-bold">Disciplina</v-col>
      <v-col cols="1" class="text-center font-weight-bold">Nota</v-col>
      <v-col cols="4" class="text-center font-weight-bold">Ações</v-col>
    </v-row>

    <!-- Lista de disciplinas -->
    <v-list class="py-0" dense>
      <v-list-item 
        v-for="(item, i) in disciplinas" 
        :key="i"
        class="px-0"
        :class="{'grey lighten-4': i % 2 === 0}"
      >
        <v-row class="align-center" dense>
          <!-- Número -->
          <v-col cols="12" sm="12" md="1" class="text-center">
            {{ i+1 }}.
          </v-col>
          
          <!-- Nome da disciplina -->
          <v-col cols="12" sm="12" md="6">
            <span 
              :class="{'font-weight-bold': item.iddisciplina < 0}"
              :style="{color: item.iddisciplina < 0 ? '#1976D2' : 'inherit'}"
            >
              {{ item.disciplina }}
            </span>
          </v-col>
          
          <!-- Nota -->
         <v-col cols="12" sm="12" md="1" class="text-center">
          <p v-if="editedpk!==item.iddisciplina" class="text-lowercase">{{item.mfd}}</p>
          <v-text-field :rules="notaRules"
            v-if="editedpk===item.iddisciplina"
            v-model="editedItemNota.mfd"
            single-line
          ></v-text-field>
        </v-col>
          
          <!-- Ações -->
          <v-col cols="4" class="text-center">
            <template v-if="editedpk !== item.iddisciplina && item.iddisciplina > 0">
              <!-- Botão Editar -->
              <v-btn
                 color="secondary"
                icon
                 class="mr-2"
                @click="bt_edit(item)"
              >
                <v-icon >mdi-pencil</v-icon>
              </v-btn>
               
            </template>
            
            <!-- Botão Salvar -->
            <v-btn
              v-if="editedpk === item.iddisciplina"
              color="primary"
              icon
              :disabled="!formValid"
              @click="bt_save(editedItemNota)"
            >
              <v-icon>save_alt</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-list-item>
    </v-list>
  </v-card-text>
   <!-- Rodapé fixo -->
    <v-card-actions class="px-6 py-4 bg-grey-lighten-4">
  <!-- Botão Voltar -->
    <v-spacer></v-spacer>
  <v-btn
    color="secondary"
    @click="prevTab()"
    class="px-6 mr-4"
    depressed
    large
    :disabled="loading"
  >
    <v-icon left>mdi-chevron-left</v-icon>
    Voltar
  </v-btn>
  

  
  <!-- Botão Finalizar -->
  <v-btn
    color="primary"
    @click="finalizarSolicitacao()"
    class="px-6"
    depressed
    large
    :loading="loading"
    :disabled="!formValid || !todosCamposPreenchidos || loading"
  >
    <v-icon left>mdi-check-circle</v-icon>
    Finalizar Solicitação
    <template v-slot:loader>
      <v-progress-circular
        indeterminate
        size="24"
        color="white"
      ></v-progress-circular>
    </template>
  </v-btn>
</v-card-actions>
</v-card>
    </v-form>
    </v-card>
    </v-container>
  </v-tab-item>
  </v-tabs>
   </div>
</div>
</template>
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import Swal from 'sweetalert2'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    datebi: null,
    date: null,
    progresso: false,
    mostrarBotaoSolicitacoes: true, // Pode ser controlado por permissões
    totalSolicitacoesPendentes: 3, // Exemplo - deve vir da sua API/store
    descricao: 'Nº do Bi',
    valid: true,
    disabledFields: true,
    menu: false,
    menubi: false,
    showAlert: false,
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 10 && v <= 20) || 'nota invalida',
      v => !isNaN(v) || 'not number ',

      v => (v== null || v.length == 2) || 'valor inválido'

    ],
    editedpk: 0,
    ano_actual: ls.get('anolectivo'),
    habilitaBi: false,
    startDate: null,
    cursos: [],
    isLoading: true,
    turmasAll: [],
    mascara: '#########-AA-###',
    turmasFiltered: [],
    municipiosAll: [],
    cor: '',
    anolectivos: [],
    municipiosFiltered: [],
    provincias: [],
    loading: false,
    loadingText:'Carregando',
    dialogConfirmar: false,
    searchInDb: '',
    estudantes: [],
    dialog: false,
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Anolectivo', value: 'anolectivo' },
      { text: 'Bi', value: 'bi' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    director: '',
    msg: '',
    tab:0,
    formValid: true,
    infoStudants:{ nome:'', instituicao:'' },
    editedIndex: -1,
    existingBi: false,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    solicitacoes:[],
    disciplinas: [],
    overlay: false,
    editedItem: {

      pkPessoa: 0,
      bi: '',
      idPessoa: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      // eslint-disable-next-line no-dupe-keys
      bi: '',
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      anolectivo: null
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      isEditRequest: false,
      dataemissaobi: '',
      // eslint-disable-next-line no-dupe-keys
      bi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null,
      anolectivo: null
    },

    editedItemNota: {
      descricao: '',
      id: '',
      iddisciplina: '',
      mfd: 0,
      p1_notaMac: '',
      idcertificado: 0,
      componente:''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    idclasse () {
      return 4
    },

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },

  // verifica se todos os campos de notas estão preenchidos na solicitação de certificado  
     todosCamposPreenchidos() {
    return this.disciplinas.every((item) => {
      // Considera campos editáveis apenas
      return item.mfd !== null && item.mfd !== '' && item.mfd !== undefined;
    });
  },
     
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    Instituicao () {
      return ls.get('i_id')
    },
     

    loggeduser(){
      return ls.get('nomeUsuario')
    }

  },

  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
     'editedItem.bi'() {
      this.$nextTick(() => {
        if (this.$refs.biField) {
           
          if( this.$refs.biField.validate() ) {
              this.verifyIfBiExists()
          }else{
            this.disabledFields=true;
          }
         
        }
      })},
  },

  created () {
    // this.CarregActividades()
    // this.initialize()
    this.initializeProvincias()
    this.initializeMunicipiosAll()
    this.initializeCursos()
    this.initializeAnolectivos()
    this.initMinhasSolicitacoes()


     if(this.$store.state.objSolicitacao){
       
       this.isEditRequest = true
       this.editedItem = this.$store.state.objSolicitacao
       this.editedItem.curso = ''
       this.editedItem.sexo = ''
     }
     else{
      this.isEditRequest = false
     }
       
    
    
  },

  methods: {
    async initialize (searchInDb) {
      try {
        //   let  payload =""
        if (!searchInDb) {
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"all"}'
        } else {
          // eslint-disable-next-line no-redeclare
          var payload = '{"anoacademico":"' + this.$store.state.idclasse + '","find":"' + searchInDb + '"}'
        }

        this.isLoading = true
        this.estudantes = await axios
          .get('/estudanteFindAll/' + payload)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
     prevTab() {
    // Lógica para voltar à tab anterior
    this.tab = 0;
  },
    // END METHOD FOR VAL
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.editedItem.bi = ''
        this.descricao = 'Nº do Bi'
        this.mascara = '#########-AA-###'
        this.ruleBI =
        [
          value => value.length === 16 || 'Minimo de caracteres exigido( 16 )'
        ]
      } else {
        this.editedItem.bi = ''
        this.descricao = 'Outro Doc.'
        this.mascara = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        this.ruleBI =
        [
          value => value.length >= 16 && value.length <= 30 || 'Minimo de caracteres exigido( 16 )'
        ]
      }
    },

    bt_edit (item) {
      this.editedIndex = this.disciplinas.indexOf(item)      
      this.editedItemNota = Object.assign({}, item)
      this.editedpk = item.iddisciplina
      this.objNotasCancelar = Object.assign({}, item)
      setTimeout(() => {}, 1000)
    },

     bt_save (editedItemNota) {
          
        this.saveNota(editedItemNota,false)
          
     
    },

    async saveNota (editedItemNota) {
      
      this.editedpk = 0
      let response = await axios.post('persistNotaSolicitacao',editedItemNota).then((res)=>res.data)
      if(response.affectedRows >= 1){
        Object.assign(this.disciplinas[this.editedIndex], editedItemNota)
      }
      setTimeout(() => {
            this.recalcularMediaFinal('',ls.get('nomeUsuario'))
      }, 1000);
      
    },

      async verifyIfBiExists() {
      if (this.editedItem.bi) {
        try { 
          let response = await axios.get(`/vericarBIEstudante/${this.editedItem.bi}`).then((res) => res.data);          
          if (response.length) {
              this.existingBi = true;
               this.infoStudants = response[0];
              this.disabledFields = true;
              this.showAlert = true
                
          }
          else {
             this.existingBi = false;
             this.disabledFields = false;
             this.showAlert = false
             this.infoStudants ={ nome:'', instituicao:'' }
          } 
        
        } catch (error) {
          console.log(error);
          
          Swal.fire(
            "Informação",
            "Erro ao verificar o némero de documento!",
            "error"
          );
        }
      }
    },

    async nextTab (){

       if (this.$refs.form.validate()) {
            try {
              this.loading = true
              await this.verifyModeloCertificado({idCurso:this.editedItem.curso.idCurso,anoLectivo:this.editedItem.anolectivo.descricao})
              // this.tab = 1
            } catch (error) {
                Swal.fire('Informação','Ocorreu um erro ao carregar as disciplinas','error')
            }finally{
               this.loading = false
            }
       }

    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    chamaDialogo () {
      this.dialog = true
    },

    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

   async finalizarSolicitacao (){


     try {
          this.overlay = true
          Swal.fire({
                title: 'Atenção!',
                text: "Ao finalizar esta solicitação, os dados não poderão ser editadas",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "green",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Finalizar",
                reverseButtons: true
              }).then(async (result) => {
                if(result.isConfirmed){
                  let response = await axios.post('/finalizarSolicitacao',this.editedItem).then((res)=>res.data)
                          if(response.affectedRows >= 1){
                              Swal.fire({
                                  title: 'Solicitação Enviada!',
                                  text: 'Sua solicitação de preparação de certificado foi enviada com sucesso. Aguarde a aprovação do IMS.',
                                  icon: 'success',
                                  confirmButtonText: 'OK'
                              });
                              this.Limpar();
                              
                              this.disabledFields=true;
                              
                              
                          }
                                }
        
        })
            
      } catch (error) {
         
      }finally{
        this.overlay = false
      }  

    },



    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)

        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeAnolectivos () {
 
      try {
        this.isLoading = true
        this.anolectivos = await axios
          .get('/AnolectivoForaEpoca')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

     async verifyModeloCertificado (item){
      try {
          let response =     await axios
            .post('/verifica-existencia-modelo', item)
            .then(res => res.data)
            if(response[0].length){
 

             // ********************************************************************
             let htmlContent = `
                    <p style="text-align: center;"><strong style="color: red;">OBS:</strong> Confirme os dados antes de finalizar o cadastramento.</p>
                    <div style="width: 90%; margin: 10 auto;">
                      <div style="display: grid; grid-template-columns: 150px auto;">
                        <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome:</strong></div>
                        <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.editedItem.nome}</div>
                        <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Bilhete:</strong></div>
                        <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.editedItem.bi}</div>
                        <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Curso:</strong></div>
                        <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.editedItem.curso.descricao}</div>
                        <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>D.Nascimento:</strong></div>
                        <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.editedItem.datanascimento}</div>
                        <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Sexo:</strong></div>
                        <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.editedItem.sexo.descricao}</div>
                        <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Ano lectivo:</strong></div>
                        <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.editedItem.anolectivo.descricao}</div>
                      </div>
                    </div>
                  `;

                  Swal.fire({
                title: "Cadastrar Estudante",
                html: htmlContent,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "green",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Guardar",
                reverseButtons: true,
              }).then(async (result) => {
                    if (result.isConfirmed) {
                      try { 

                          let response = await this.saveCadastro();

                            const [[{ rows_inserted } = {}] = []] = response || [];

                            if (rows_inserted >= 1) {
                                this.obterDisciplinasPreparacao();
                            } else {
                                console.error("Nenhuma linha foi inserida ou resposta inválida:", response);
                            }

                        
                      } catch (error) {
                        console.log(error);
                        
                        Swal.fire("Erro", "Erro ao cadastrar estudante", "error");
                      } finally {
                       }
                    }  
                  });

            }else{
               Swal.fire('Informação','Modelo de configuração do certificado para este anolectivo não definido, entre em contacto com o suporte','info')
            }
            
         } catch (error) {
        }
    },


    async obterDisciplinasPreparacao(){
         try {
          this.disciplinas =  await axios.post('/ObterDisciplinasPreparacao', {identificador: this.editedItem.bi}).then((res)=>res.data);
             
          this.addDisciplinasClassificacao()
          this.tab = 1                        
         } catch (error) {
            console.log(error);
            
         }

    },

    async initMinhasSolicitacoes () {
 
      try {
        this.isLoading = true
        this.solicitacoes = await axios
          .get('/getSolicitacoesInstituicao')
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    

    

    close () {
      this.dialog = false
      this.$refs.form.reset()
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(datebi).toISOString().substr(0, 10)
    },

    verSolicitacoes (){
      this.$router.push('/estudante/minhas-solicitacoes')
    },

    recalcularMediaFinal (){

       
          let soma = 0;
          let pc  = 0;
          var mediaFinal = 0
          let Pap = this.disciplinas.filter(c=>c.disciplina === 'Classificação da Prova de Aptidão Profissional (PAP)')
          let Ec = this.disciplinas.filter(c=>c.disciplina === 'Classificação do Estágio Curricular(EC)')
          this.disciplinas.forEach(element => {
            if(element.iddisciplina >0) 
              soma += (element.mfd === null || element.mfd === '')?0: parseInt(element.mfd)
          });
          pc = Math.round(soma / parseInt(this.disciplinas.length-2))
      
          mediaFinal = Math.round((4 * pc + parseInt((Pap[0].mfd === null || Pap[0].mfd === '')?0:Pap[0].mfd) + parseInt((Ec[0].mfd === null || Ec[0].mfd === '')?0:Ec[0].mfd)) / 6)


          this.disciplinas.filter(c=>c.disciplina === 'Classificação Final do Plano Curricular (PC)')[0].mfd = pc
          this.disciplinas.filter(c=>c.disciplina === 'Classificação Final do Curso=(4XPC+PAP+EC)/6')[0].mfd=mediaFinal
    
      
      },

      addDisciplinasClassificacao(matricula_,autor_){
           // Verifica se já existem as classificações no array de disciplinas
              let classFinal = this.disciplinas.find(c => c.disciplina === 'Classificação Final do Curso=(4XPC+PAP+EC)/6');
              let classPlanoCurricular = this.disciplinas.find(c => c.disciplina === 'Classificação Final do Plano Curricular (PC)');

              // Função auxiliar para adicionar uma nova disciplina, evitando repetição de código
              const adicionarDisciplina = (descricao, id, mfd) => {
                  this.disciplinas.push({
                      matricula: matricula_,
                      autor: autor_,
                      id_disciplina: id,
                      iddisciplina: id,
                      descricao: descricao,
                      disciplina: descricao,
                      idcertificado: id,
                      mfd: '',
                      componente: 3
                  });
              };

              // Adiciona a disciplina caso não exista
              if (!classPlanoCurricular) {
                  adicionarDisciplina('Classificação Final do Plano Curricular (PC)', -1, 0);
              }

              if (!classFinal) {
                  adicionarDisciplina('Classificação Final do Curso=(4XPC+PAP+EC)/6', -2, 0);
              }

      },

    async saveCadastro () {
      if (this.$refs.form.validate()) {
        this.dialogConfirmar = false
        // Check the student´s age , less than 14 won´t be allowed to study on high school
        let ano_nascimento = this.editedItem.datanascimento.toString().split('-')[0]
        if ((this.ano_actual - ano_nascimento) >= 14) {
          this.progresso = true

          const ls = require('local-storage')
          var params = {
            pkPessoa: this.editedItem.pkPessoa,
            idPEssoa: this.editedItem.bi,
            idMunicipio: this.municSelectedForComb.idMunicipio,
            municipio: this.municSelectedForComb.descricao,
            provincia: this.proviSelectedForComb.descricao,
            idPerfil: 1,
            nome: this.editedItem.nome,
            morada: this.editedItem.morada,
            telefone: this.editedItem.telefone,
            autor: this.loggeduser,
            datanascimento: this.editedItem.datanascimento,
            data_: this.editedItem.data_,
            status_2: this.editedItem.status_2,
            email: this.editedItem.email,
            sexo: 'M',
            nomedopai: this.editedItem.nomedopai,
            nomedamae: this.editedItem.nomedamae,
            dataemissaobi: this.editedItem.dataemissaobi,
            bi: this.editedItem.bi,
            ResidenteEm: 1,
            instituicao: ls.get('i_id'),
            instituicaodescricao: this.instituicaodescricao,
            curso: this.editedItem.curso,
            anolectivo: this.editedItem.anolectivo,
            idanoacademico: this.idclasse,
            addressURL: window.location.host,
            notas: this.disciplinas,
           }
          
          try {
            this.overlay = true
            let result= await axios.post('/solicitarCadastroAnosAnteriores', params).then(res => res.data);
            
            return result
            
              
              
            // if(response.affectedRows >= 1){

            //     Swal.fire({
            //       title: 'Informação',
            //       text: 'A sua solicitação foi enviada para a escola IMS Central para validação. Acompanhe o status em "Minhas Solicitações".',
            //       icon: 'success'
            //     });

            //     this.Limpar()
            //     this.initMinhasSolicitacoes()

            // }
            // else if(response.code.toString().includes('ER_DUP_ENTRY')){
            //     Swal.fire('Informação','Nº de Bilhete já existente','warning')
            // }else
            //   Swal.fire('Informação','Ocorreu um erro ao efectuar essa operação','error')
            
          } catch (error) {

              
                Swal.fire('Informação','Ocorreu um erro ao efectuar essa operação','error')
              
          }finally{
            this.overlay = false
          }
 
 
        } else {
          this.text = "O estudante tem a idade( '" + (this.ano_actual - ano_nascimento) + "' anos ) inferior a permitida pelo sistema.( Idade minima 14 anos )"
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        }
      }
    },

     getClasse(idclasse) {
      switch (idclasse) {
        case 1:
          return "10ª classe";
        case 2:
          return "11ª classe";
        case 3:
          return "12ª classe";
        case 4:
          return "13ª classe";
      }
    },
  
    Limpar () {
      Object.assign(this.editedItem, this.defaultItem)
      this.$store.state.objSolicitacao = null;
      this.municSelectedForComb= null;
      this.proviSelectedForComb= null;
      this.disciplinas = [];
      this.tab = 0;
      this.$nextTick(() => {
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
          });
      
    },

  
  }
}
</script>
 <style scoped>
.formPosition {
   margin: 0 auto;
  padding: 20px;
}

.v-card {
  border-radius: 8px !important;
}

.v-toolbar {
  border-radius: 8px 8px 0 0 !important;
}

.v-card__actions {
  border-radius: 0 0 8px 8px !important;
}

</style>
